export const CHANGE_ATTR = "AUTH_CHANGE_ATTR"
export const SET_ERROR = "AUTH_ADD_ERROR"